
import Typography from '@mui/material/Typography';


export const TextDrugCelecoxib = () => {

return(
<div>
    
<Typography variant="h6" >
<br />

Celecoxib is used to relieve pain, tenderness, swelling and stiffness caused by osteoarthritis (arthritis caused by a breakdown of the lining of the joints), 
rheumatoid arthritis (arthritis caused by swelling of the lining of the joints), and ankylosing spondylitis (arthritis that mainly affects the spine). 
Celecoxib is also used to treat juvenile rheumatoid arthritis (a type of arthritis that affects children) in children 2 years of age and older. 
Celecoxib is also used to treat painful menstrual periods and to relieve other types of short-term pain including pain caused by injuries, surgery and other medical or 
dental procedures, or medical conditions that last for a limited time. Celecoxib is in a class of NSAIDs called COX-2 inhibitors. 
It works by stopping the body's production of a substance that causes pain and inflammation.
<br /><br />



Sources: <br /><br />
https://medlineplus.gov/druginfo/meds/a699022.html

</Typography>

</div>

)
}